export interface IssueGroup {
  label: string;
  options: string[];
}

export const issueTypeGroups: IssueGroup[] = [
  {
    label: 'Accidental Damage',
    options: [
      'Fire',
      'Dropped',
      'Natural Disaster',
      'Cracked Screen',
      'Cracked Back',
      'Cracked Camera',
      'Liquid Damage',
      'Other',
    ],
  },
  {
    label: 'Malfunctions',
    options: ['Power Surge Lightning', 'Flood', 'Screen', 'Camera', 'Charging Port', 'Battery', 'Other'],
  },
  {
    label: 'Theft and Vandalism',
    options: ['Theft', 'Theft from Unattended Vehicle', 'Vandalism', 'Other'],
  },
  {
    label: 'Loss',
    options: ['Mysterious Disappearance', 'Accidental Loss', 'Irretrievable Loss'],
  },
];

export const operabilityOptions = [
  'Still fully functional, just some annoyances',
  'Functional, but intermittent issues',
  'Functional, but less than half the time',
  'Completely unusable',
];
